const Section = ({
  children,
  ref = null,
  bgColor = "bg-white",
  bgImage = null,
  overlayColor = "rgba(226, 183, 185, .80)", 
}) => {
  return (
    <div
      ref={ref}
      className={`section ${bgColor} relative w-full z-10`}
      style={{
        backgroundImage: bgImage ? `url(${bgImage})` : undefined,
        backgroundRepeat: bgImage ? "repeat" : undefined,
        backgroundPosition: bgImage ? "center" : undefined,
      }}
    >
      {bgImage && (
        <div
          className="section absolute w-full inset-0 pointer-events-none z-10"
          style={{
            backgroundColor: overlayColor,
          }}
        />
      )}
      <div className="section w-full relative z-10">
          {children}
      </div>
    </div>
  );
};

export default Section;
